import { apiFetch } from "../client"

export interface DashboardPortfolioSummaryRow {
  bucket: string
  loanCount: number
  outstandingAmount: number
  averageDaysOverdue: number
  penaltyAmount: number
  totalRepaid: number
  totalDueAmount: number
  recoveryRate: number
  currency: string
}

export interface DashboardPortfolioTrendRow {
  metricDate: string
  outstandingAmount: number
  recoveredAmount: number
  penaltyAmount: number
  currency: string
}

export interface DashboardMicroLoanSummary {
  activeLoans: number
  portfolioValueUsd: number
  overdueRate: number
  promotionsMtd: number
  demotionsMtd: number
  tierDistribution: Array<{
    tier: string
    clientCount: number
    percentage: number
  }>
}

export interface DashboardPortfolioResponse {
  summary: Record<string, unknown>
  distribution: DashboardPortfolioSummaryRow[]
  lifecycleBreakdown: Array<{ lifecycleStage: string; loanCount: number }>
  topRegions: Array<{ region: string; loanCount: number; outstandingAmount: number; currency: string }>
  trend: DashboardPortfolioTrendRow[]
  microLoanSummary: DashboardMicroLoanSummary
}

export interface DashboardAlert {
  key: string
  variant: "info" | "warning" | "danger" | "success"
  title: string
  count: number
  amount?: number
  actionPath?: string | null
}

export function listDashboardAlerts(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<{ data: DashboardAlert[] }>(`/dashboard/alerts${query}`)
}

export function getDashboardKpis(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/dashboard/kpis${query}`)
}

export function getDashboardPortfolio(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<{ data: DashboardPortfolioResponse }>(`/dashboard/portfolio${query}`)
}

export function getDashboardAgentOperations(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/dashboard/agent-operations${query}`)
}

export function getDashboardKycPipeline(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/dashboard/kyc-pipeline${query}`)
}

export function getDashboardReportsSummary() {
  return apiFetch<any>("/dashboard/reports-summary")
}

export function getDashboardMyWork() {
  return apiFetch<any>("/dashboard/my-work")
}

export function getDashboardMyPerformance(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/dashboard/my-performance${query}`)
}

export function getDashboardVerification() {
  return apiFetch<any>("/dashboard/verification")
}
